import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'timesum' })
export class TimesumPipe implements PipeTransform {

    transform(value: any, showMinutes = false, suffix = 's'): any {
        if (typeof value !== 'number') {
            return '0' + suffix;
        }
        if (value > 3600) {
            const h = Math.trunc(value / 3600);
            const m = Math.trunc((value % 3600) / 60);
            const s = Math.trunc(value % 60);
            return h + ':' + this.addZero(m) + ':' + this.addZero(s) + suffix;
        }
        else if (value > 60) {
            const m = Math.trunc(value / 60);
            const s = Math.trunc(value % 60);
            return m + ':' + this.addZero(s) + suffix;
        }
        else {
            return showMinutes
                ? '0:' + this.addZero(Math.trunc(value)) + suffix
                : Math.trunc(value) + suffix;
        }
    }

    addZero(n: any): any {
        return n < 10 ? '0' + n : n;
    }

}
